import UnauthorizedAccessWidget from './UnauthorizedAccessWidget';

export default UnauthorizedAccessWidget;
